import { createInputBindings } from '@gift/website-state/slices/inputsSlice';
import { ColorAttributeInput } from '@gift/attributes-color-core/ColorAttributeInput';
import { ColorAttributeOptions } from '@gift/attributes-color-core/ColorAttributeOptions';
import { createOptionBindings } from '@gift/website-state/slices/variablesSlice';
import { createSelector } from '@reduxjs/toolkit';

const { createInputSelector, createInputUpdater }
    = createInputBindings<ColorAttributeInput>();

export const selectValueById = createInputSelector(i => i.value);
export const updateValueByIds = createInputUpdater('value');

const { createOptionSelector } = createOptionBindings<ColorAttributeOptions>();

export const selectColorChoicesById = createOptionSelector(i => i.choices);
export const selectComponentById = createOptionSelector(i => i.component);

export const selectColorChoiceById = createSelector([
    selectColorChoicesById,
    selectValueById
], (choices, value) => {
    return choices!.find(c => c.value === value!)!;
});
